module.exports = __webpack_public_path__ + "img/vitawallet.9e62bc1.png";